import { useEffect } from 'react'
import { FiAward, FiCalendar, FiUsers } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import PageHeader from '../../admin/components/PageHeader'
import '../../styles/admin.css'

import { getPlayerNameFromCookie } from '../store/MetaStore'

function LeagueMenuView() {
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  let pageName = getPlayerNameFromCookie() || 'League Info'

  return (
    <>
      <PageHeader pageName={pageName} />
      <div className="admin-menu-grid">
        <div className="admin-menu-card" onClick={() => navigate(`/league/golfers`)}>
          <div className="admin-menu-icon" style={{ color: '#060' }}>
            <FiUsers />
          </div>
          <div className="admin-menu-title">Golfer Info</div>
        </div>
        <div className="admin-menu-card" onClick={() => navigate(`/league/rounds`)}>
          <div className="admin-menu-icon" style={{ color: '#060' }}>
            <FiCalendar />
          </div>
          <div className="admin-menu-title">Results</div>
        </div>
        <div className="admin-menu-card" onClick={() => navigate(`/league/prizes`)}>
          <div className="admin-menu-icon" style={{ color: '#060' }}>
            <FiAward />
          </div>
          <div className="admin-menu-title">Prizes</div>
        </div>
      </div>
    </>
  )
}

export default LeagueMenuView
